import { ReactElement, useContext } from "react"

import { SYS_ADMIN_LCT_STEPS } from "../../../../../constants/lct/evac/deviceForm"
import AppStepper from "../../../../dataDisplay/stepper/appStepper"
import { CreateEbDeviceContext } from "../providers/baseProviders/createEbDeviceProvider"

const NON_SYS_ADMIN_EB_STEPS = [
    "Core Electric Boiler Details",
    "Upload Supporting Files",
    "Review and Submit",
]

/** AppStepper for Electric Boiler device creation
 */
const CreateEbDeviceProgressStepper = (): ReactElement => {
    const { currentIndex, canEditManufacturer } = useContext(
        CreateEbDeviceContext
    )

    const steps = canEditManufacturer
        ? [...SYS_ADMIN_LCT_STEPS, ...NON_SYS_ADMIN_EB_STEPS]
        : NON_SYS_ADMIN_EB_STEPS

    return <AppStepper stepLabels={steps} currentStepIndex={currentIndex} />
}

export default CreateEbDeviceProgressStepper
